
import firebaseApp from './firebaseApp'
import 'firebase/auth'
import firebase from 'firebase'
const auth = firebaseApp.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.SESSION)

export default auth